<template>
  <vx-tooltip-with-slot-text position="bottom">
    <template v-slot:text>
      <span class="tooltip-content">{{ errorMessage }}</span>
    </template>

    <template v-slot:inner>
      <span class="material-icons error-icon">
        error
      </span>
    </template>
  </vx-tooltip-with-slot-text>
</template>

<script>
import VxTooltipWithSlotText from "./vx-tooltip/VxTooltipWithSlotText.vue";

export default {
  name: "TooltipValidationAlert",
  components: {
    VxTooltipWithSlotText,
  },
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.error-icon {
  font-size: 12px;
  color: $aisea-red;
  display: block;
  cursor: pointer;
}

.tooltip-content {
  font-size: 12px;
  white-space: nowrap;
}
</style>
